import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon42: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#A84A76"
        d="M10.003 0C11.106 0 12 .894 12 1.998V3h2.46l.04-.003.041.002L15.5 3a.5.5 0 0 1 0 1H15v12.024a3.973 3.973 0 0 1-3.775 3.968l-.198.005H4.973A3.973 3.973 0 0 1 1 16.024V4H.5a.5.5 0 0 1-.492-.41L0 3.5A.5.5 0 0 1 .5 3h.96l.04-.003.041.002L4 3V1.998C4 .944 4.814.082 5.848.005L5.997 0h4.006ZM14 4H2v12.024a2.973 2.973 0 0 0 2.798 2.968l.175.005h6.054A2.973 2.973 0 0 0 14 16.024V4ZM4.5 6a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-1 0v-10a.5.5 0 0 1 .5-.5ZM8 6a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-1 0v-10A.5.5 0 0 1 8 6Zm3.5 0a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-1 0v-10a.5.5 0 0 1 .5-.5Zm-1.497-5H5.997A.997.997 0 0 0 5 1.998V3h6V1.998a.997.997 0 0 0-.881-.991L10.003 1Z"
      />
    </Svg>
  )
}
